module.exports = __webpack_public_path__ + "img/can2.b7c3df34.png";